import { render, staticRenderFns } from "./TemplateMessageChartModal.vue?vue&type=template&id=2f01f064&"
import script from "./TemplateMessageChartModal.vue?vue&type=script&lang=js&"
export * from "./TemplateMessageChartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports